'use strict';

/**
 * Validación server-to-server Mi Docta (sin tokenVeDi en URL).
 * POST api/IntegracionMiDocta/ValidarSesion
 */
angular.module('TurneroApp').service('integracionMiDoctaApiService', ['$http', 'portal', function ($http, portal) {
    this.validarSesion = function (sesionId) {
        return $http.post(portal.getUrlServer() + 'api/IntegracionMiDocta/ValidarSesion', { sesionId: sesionId }, { manejarErrorIngreso: true })
            .then(function (response) {
                return response.data;
            });
    };
}]);



// WEBPACK FOOTER //
// ./app/shared/integracionMiDocta/integracionMiDoctaApiService.js